<div class="form-group">
    <label class="input-label">Number of rows required in Grid</label>
    <select class="form-control"
            name="fieldOptions.validate.requiredRows"
            [(ngModel)]="fieldOptions.validate.requiredRows"
            (ngModelChange)="dataChangedEvent($event)"
            class="form-control">
        <option value=""></option>
        <option *ngFor="let guide of visibleGuides" value="data.{{guide.formIoId}}">{{guide.title}}</option>
    </select>
</div>